import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

// Shared lookups: team members + settings, used to populate dropdowns.
export function useLookups() {
  const [team, setTeam] = useState([]);
  const [settings, setSettings] = useState({});

  const load = useCallback(async () => {
    const [t, s] = await Promise.all([
      api.get("/data/team_members"),
      api.get("/config/settings"),
    ]);
    setTeam(t.data);
    setSettings(s.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const byFunction = (fn) =>
    team.filter((m) => m.function === fn && m.status === "Active")
      .map((m) => ({ value: m.employee_id, label: m.name }));

  const nameMap = Object.fromEntries(team.map((m) => [m.employee_id, m.name]));

  const lists = {
    telecallers: byFunction("Telecalling"),
    counsellors: byFunction("Counselling"),
    bd: byFunction("Business Development"),
    faculty: byFunction("Faculty"),
    team: team.filter((m) => m.status === "Active").map((m) => ({ value: m.employee_id, label: `${m.name} (${m.function})` })),
    courses: settings.courses || [],
    sources: settings.lead_sources || [],
    channels: settings.channels || [],
  };

  return { team, settings, lists, nameMap, reload: load };
}
